export const LANGUAGE_STORAGE_KEY = 'i18nextLng';

export const THEME_STORAGE_KEY = 'theme';

export const CONSOLE_EXPERIENCE_STORAGE_KEY = 'sda-console-experience';

export const PRESERVED_STORAGE_KEYS: readonly string[] = [
  LANGUAGE_STORAGE_KEY,
  THEME_STORAGE_KEY,
  CONSOLE_EXPERIENCE_STORAGE_KEY,
];

export const clearStorageKeepingPreferences = (): void => {
  const preserved = PRESERVED_STORAGE_KEYS.map(
    (key) => [key, localStorage.getItem(key)] as const,
  );

  localStorage.clear();

  preserved.forEach(([key, value]) => {
    if (value !== null) localStorage.setItem(key, value);
  });
};
